document.addEventListener('DOMContentLoaded', function() {
    var slides = document.querySelectorAll('.banner__slide');

    slides.forEach(function(slide, index) {
        var image = slide.querySelector('.banner__slideImage img');
        var button = slide.querySelector('.banner__buttons a');

        if (image && button) {
            image.addEventListener('click', function() {
                button.click();
            });
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var headerWrapper = document.querySelector('.header-wrapper');

    if (headerWrapper) {
        headerWrapper.id = 'new_nome_header';
    }
});
